

























































































































































// vue
import { defineComponent, onBeforeMount, ref } from '@vue/composition-api';
import { useStore } from '@/store';

// components
import Surface from '@/vue3/components/Surface.vue';

// services
import { useService } from '@/vue3/api/services';

export default defineComponent({
    components: {
        Surface,
    },
    setup() {
        // reactive
        const weatherData = ref();
        const sunsetTime = ref();
        const sunriseTime = ref();

        const lastUpdatedTime = ref("")

        // hooks
        const store = useStore();
        const { getWeatherLatest } = useService();

        // methods
        // converts UNIX time to hours and minutes
        const unixToTime = (unixTimestamp: number): string => {
            var date = new Date(unixTimestamp * 1000);
            var hours = date.getHours();
            var minutes = '0' + date.getMinutes();
            var formattedTime = hours + ':' + minutes.substr(-2);
            return formattedTime;
        };

        const refreshLastUpdatedTime = () => {
            const utcSeconds = weatherData.value['dt'];
            const lastUpdated = new Date(0);
            lastUpdated.setUTCSeconds(utcSeconds);

            const currentTime   = new Date();
            const milliseconds = (currentTime.getTime() - lastUpdated.getTime());
            const lastUpdatedMinutes = Math.round(milliseconds/(1000*60));

            if(lastUpdatedMinutes < 2){
                lastUpdatedTime.value = `now`
            }
            else if(lastUpdatedMinutes < 105){
                lastUpdatedTime.value = `${lastUpdatedMinutes} minutes ago`
            }
            else {
                lastUpdatedTime.value = `${lastUpdatedMinutes/60} hours ago`
            }
        }

        const forceUpdateWeatherData = async () => {
            weatherData.value = await getWeatherLatest(
                store.getters.currentCourseSchema.id,
                true
            );
            await getWeather();
        }

        const calculateTime = () => {
            sunsetTime.value = unixToTime(sunsetTime.value);
            sunriseTime.value = unixToTime(sunriseTime.value);
        };

        const getWeather = async () => {
            weatherData.value = await getWeatherLatest(
                store.getters.currentCourseSchema.id,
            );
            sunsetTime.value = weatherData.value.sys.sunset;
            sunriseTime.value = weatherData.value.sys.sunrise;
            calculateTime();
            refreshLastUpdatedTime();
        };

        // lifecycle
        onBeforeMount(async () => {
            await getWeather();
            setInterval(getWeather, 1000 * 60 * 5);
        });

        return {
            weatherData,
            sunsetTime,
            sunriseTime,
            lastUpdatedTime,
            forceUpdateWeatherData,
        };
    },
});
